import { NgModule } from 'ng-metadata/core';
import {FormBuilderService} from './formBuilder.service';
import {PrmFormField} from './field/formField.directive';
import {FormFieldService} from './field/formField.service';
import {PrmSelectSearchAttribute} from "./field/selectSearchAttribute.directive";

@NgModule({
    declarations: [
        PrmSelectSearchAttribute
    ],
    providers: [
        FormBuilderService,
        FormFieldService
    ],
    imports:[
    ]
})
export class FormBuilderModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/formBuilder/formBuilder.module.ts